import React, { useMemo } from 'react';

import { Typography } from '@gogame/components';

const FILTER_LIST_MAX_ITEMS = 10;

const FilterDetailsItem = ({ label, value, lastItem }) => {
  const displayValue = useMemo(() => {
    let displayValue;

    if (Array.isArray(value)) {
      if (value.length > FILTER_LIST_MAX_ITEMS) {
        displayValue = [
          ...value.slice(0, FILTER_LIST_MAX_ITEMS).map(({ name }) => name),
          `+ ${value.length - FILTER_LIST_MAX_ITEMS} others`,
        ];
      } else {
        displayValue = value.map(({ name }) => name);
      }

      displayValue = displayValue.join(', ');
    } else {
      displayValue = value?.name || value;
    }

    return displayValue;
  }, [value]);

  return (
    <Typography variant={'caption'}>
      {label}: {displayValue}
      {lastItem ? '.' : ';'}
    </Typography>
  );
};

export default FilterDetailsItem;
